<template>
    <v-container
        fluid
        class="pa-0 pt-6"
    >
        <v-row 
            :class="{
                'justify-space-between': $vuetify.breakpoint.smOnly,
                'align-start': !$vuetify.breakpoint.smOnly
            }"
        >
            <v-col
                class="text-center"
                cols="12"
                sm="3"
                md="4"
                lg="3"
            >
                <DisclaimerButton
                    :gtmId="$vuetify.breakpoint.xsOnly ? 'gtm-gpdr-cta-accept-policies' : 'gtm-gpdr-cta-reject-policies'"
                    :key="$vuetify.breakpoint.xsOnly ? 'acceptPoliciesButton'  : 'rejectPoliciesButton'"
                    :text="$vuetify.breakpoint.xsOnly ? $t('gpdr.cookieDisclaimer.cta.acceptAll') : $t('gpdr.cookieDisclaimer.cta.rejectAll')"
                    :isOutlined="false"
                    :backgroundColor="$vuetify.breakpoint.xsOnly ? '#388E3C' : null"
                    :textColor="$vuetify.breakpoint.xsOnly ? '#FFFFFF' : null"
                    @click-action="$vuetify.breakpoint.xsOnly ? acceptPolicies() : rejectPolicies()"
                />
            </v-col>
            <v-col
                class="text-center"
                cols="12"
                sm="3"
                md="4"
                lg="3"
            >
                <DisclaimerButton
                    gtmId="gtm-gpdr-cta-settings"
                    key="settingsButton"
                    :text="$t('gpdr.cookieDisclaimer.cta.settings')"
                    :thickBorder="true"
                    @click-action="openSettings"
                />
            </v-col>
            <v-col
                cols="12"
                sm="3"
                md="2"
                lg="2"
            >
                <DisclaimerButton
                    :gtmId="$vuetify.breakpoint.xsOnly ? 'gtm-gpdr-cta-reject-policies' : 'gtm-gpdr-cta-accept-policies'"
                    :key="$vuetify.breakpoint.xsOnly ? 'rejectPoliciesButton' : 'acceptPoliciesButton'"
                    :text="$vuetify.breakpoint.xsOnly ? $t('gpdr.cookieDisclaimer.cta.rejectAll') : $t('gpdr.cookieDisclaimer.cta.acceptAll')"
                    :isOutlined="false"
                    :backgroundColor="$vuetify.breakpoint.xsOnly ? null : '#388E3C'"
                    :textColor="$vuetify.breakpoint.xsOnly ? null : '#FFFFFF'"
                    @click-action="$vuetify.breakpoint.xsOnly ? rejectPolicies() : acceptPolicies()"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import DisclaimerButton from '@/components/gdpr/components/DisclaimerButton';

    export default {
        name: 'DisclaimerFooter',
        components: {
            DisclaimerButton
        },
        methods: {
            openSettings() {
                this.$emit('open-settings');
            },
            acceptPolicies() {
                this.$emit('accept-policies');
            },
            rejectPolicies() {
                this.$emit('reject-policies');
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/gdpr/layout/DisclaimerFooter.vue